import { post } from "@shared/utils/server";

export async function fetchRedeemProviderBalance(): Promise<unknown | null> {
  const res = await post({
    method: "Game.redeemProviderBalance",
    args: {},
  });

  if (!res || res instanceof Error) {
    return null;
  }

  return res;
}
